import { FC } from 'react'
import cx from 'classnames'
import { ImageProps } from 'next/image'

import { VideoProps } from '../Video'
import { useRichText } from '../../relay/RichText/useRichText'
import RichText from '../RichText'

import * as SC from './styled'

export type AdsDescriptionProps = {
  className?: string
  video?: VideoProps
  image?: ImageProps
  title: string
  text: string | any[] | null
}

const AdsDescription: FC<AdsDescriptionProps> = ({
  className,
  video,
  image,
  title,
  text,
}) => {
  const richTextProps = useRichText(text)

  return (
    <SC.AdsDescription className={cx('AdsDescription', className)}>
      {image && <SC.MainImage {...image} />}
      {video && <SC.MainVideo {...video} />}
      <SC.Title>{title}</SC.Title>
      <RichText {...richTextProps} />
    </SC.AdsDescription>
  )
}

export default AdsDescription
